import Compliance from '@hoa/svg/ServiceRequst/SelfQualif/Compliance.svg';
import ElectricalInstallation from '@hoa/svg/ServiceRequst/SelfQualif/ElectricalInstallation.svg';
import Repair from '@hoa/svg/ServiceRequst/SelfQualif/Repair.svg';
import CertificateOfCompliance from '@hoa/svg/ServiceRequst/SelfQualif/CertificateOfCompliance.svg';
import ElectricalDiagram from '@hoa/svg/ServiceRequst/SelfQualif/ElectricalDiagram.svg';
import Other from '@hoa/svg/ServiceRequst/SelfQualif/Other.svg';

import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';
import { t } from 'i18next';

export const typeOfInterventionStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:typeofIntervention.title`,
  additionalCopy: `quote:additionalCopy.description.title`,
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.TILES,
      summaryTitle: `quote:description.summaryTitle`,
      props: {
        name: `intervention_type`,
        options: [
          {
            label: `quote:typeofIntervention.new_installation`,
            value: `new_installation`,
            icon: <ElectricalInstallation />,
            flow: `RFQ`,
          },
          {
            label: `quote:typeofIntervention.compliance`,
            value: 'compliance',
            icon: <Compliance />,
            flow: `RFQ`,
          },
          {
            label: `quote:typeofIntervention.electrical_diagram`,
            value: 'electrical_diagram',
            icon: <ElectricalDiagram />,
            flow: `IR`,
            price: `379€`,
          },
          {
            label: `quote:typeofIntervention.electrical_diagram_and_compliance_certificate`,
            value: 'electrical_diagram_and_compliance_certificate',
            treeId: `609`,
            icon: <ElectricalDiagram />,
            flow: `IR`,
            price: `499€`,
          },
          {
            label: `quote:typeofIntervention.certificate_of_compliance`,
            value: 'certificate_of_compliance',
            icon: <CertificateOfCompliance />,
            flow: `IR`,
            price: `179€`,
          },
          {
            label: `quote:typeofIntervention.certificate_of_compliance_peb`,
            value: 'certificate_of_compliance_peb',
            icon: <CertificateOfCompliance />,
            flow: `IR`,
            price: `${t(
              `quote:electricians.steps.priceByLocale.certificateOfCompliancePEB`,
            )}`,
          },
          {
            label: `quote:typeofIntervention.repair`,
            value: 'repair',
            icon: <Repair />,
            flow: `IR`,
            price: `99€`,
          },
          {
            label: `quote:typeofIntervention.other`,
            value: 'other',
            icon: <Other />,
            flow: `RFQ`,
          },
        ],
        placeholder: `quote:description.placeholder`,
        validation: [`isRequired`],
      },
    },
  ],
};
